var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"padless":"","fixed":"","color":"#76082f"}},[_c('v-col',{staticClass:"text-center",attrs:{"color":"white","cols":"12"}},[_c('a',{staticClass:"white--text text-subtitle-2",attrs:{"id":"aviso-privacidad"},on:{"click":_vm.verAvisoPrivacidad}},[_vm._v(" Consulta el Aviso de Privacidad Simplificado de Trámites en línea ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }